<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <form>

                    <div class="form-group row">
                        <label for="companyName" class="col-sm-4 col-form-label text-md-right">Company Name</label>

                        <div class="col-md-6">
                            <input id="companyName" type="text" v-model="companyName"
                                   class="form-control" name="companyName" autofocus>
                        </div>
                    </div>

                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                  @vdropzone-success="uploadSuccess"
                                  @vdropzone-sending="sendingFiles"
                                  @vdropzone-file-added="fileAdded"
                                  @vdropzone-removed-file="fileRemoved"></vue-dropzone>

                    <div class="form-group row mb-0">
                        <div class="col-md-8 offset-md-4">
                            <button
                                type="submit"
                                class="btn btn-primary"
                                disabled
                                @click.prevent="addCompany"
                            >
                                Add Company
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {store} from "../../store";
    import {mapGetters} from "vuex";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import createEntity from "../../mixins/create-entity";

    export default {
        mixins: [createEntity],

        created(){
            this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/company/store',
                thumbnailWidth: 150,
                maxFilesize: 5,
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                },
                autoProcessQueue: false,
                addRemoveLinks: true,
                uploadMultiple: true
            }
        },
        data: () => ({
            companyName: '',
            numOfFiles: 0,

        }),
        components: {
            vueDropzone: vue2Dropzone
        },
        computed: {
            ...mapGetters([
                'getToken'
            ]),
            validInput(){
                return this.companyName != '' && this.numOfFiles
            }
        },
        methods:{
            addCompany(){
                this.$refs.myVueDropzone.processQueue();
            },
            sendingFiles(file, xhr, formData){
                formData.append('company_name', this.companyName);
            },
            uploadSuccess(file, response){
                let scope = this;
                setTimeout(function () {
                    scope.$refs.myVueDropzone.removeAllFiles()
                }, 2000);
            },
            fileAdded(){
                this.numOfFiles++;
            },
            fileRemoved(){
                this.numOfFiles--;
            }
        },
    }
</script>

<style scoped>

</style>
